function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    padding-top: ",
        "px;\n\n    .with-sidebar {\n        display: flex;\n        flex-wrap: wrap;\n        align-items: stretch;\n        height: calc(100vh - ",
        "px);\n        overflow: hidden;\n    }\n\n    .with-sidebar > :first-child {\n        flex-grow: 1;\n    }\n\n    .with-sidebar > :last-child {\n        flex-basis: 0;\n        flex-grow: 999;\n        min-width: 50%;\n        overflow: auto;\n        height: 100%;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import styled from 'styled-components';
export var LayoutContainer = styled.div(_templateObject(), function(p) {
    return p.$marginTop;
}, function(p) {
    return p.$marginTop;
});
